import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import ItemService from "../../../../../services/customer_appCommonService";
import { useSelector, useDispatch } from "react-redux"; //useDispatch
import { getSupplierCategorySelection } from "../../../../../redux/feature/supplier_app/supplierSlice";
import { InputField } from "../../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../../Components/formElements/ComboboxField";
import DataTable from "react-data-table-component";
import Constants from "../../../../../common/SupplierConstants";
import FailureModal from "../../../../../Components/Modal/supplier_app/FailureModal";
import {
  validateName,
  validateRequired,
  validPostalCode,
} from "../../../../../common/Validations";
import CustomerConstants from "../../../../../common/CustomerConstants";
import { TextAreaField } from "../../../../../Components/formElements/TextAreaField";
const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
};

const GodownRegistration = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Customer");
  localStorage.setItem("submenu", "Customer List");

  // let userInfo = useSelector((state) => state?.user?.data); // User Details from Store
  let selectedCategoryData = useSelector(
    (state) => state?.supplier?.selectedCategory
  );

  let dropdownOption = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];
  let routNumberDropdownOption = [
    {
      id: "1",
      name: "1",
    },
    {
      id: "2",
      name: "2",
    },
    {
      id: "3",
      name: "3",
    },
  ];
  let productDocumentAttachment = [
    {
      id: "1",
      name: "Google Pin location",
    },
    {
      id: "2",
      name: "Project Photos",
    },
    {
      id: "3",
      name: "Blueprints or Layout Plans",
    },
    {
      id: "5",
      name: "Project Document",
    },
  ];

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  // let requiredFields = [];

  const [getDropdownData, setDropdownData] = useState("");
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  const [getSelectedData, setSelectedData] = useState([]);
  const [getDisabledRemove, setDisabledRemove] = useState(true);
  console.log("getSelectedData>>", getSelectedData);
  console.log("getSelectedData>>", getDisabledRemove);

  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);
  const [getcontactPosition, setcontactPosition] = useState([]);
  const [getTitle, setTitle] = useState([]);

  const [getDocumentTypeData, setDocumentTypeData] = useState([]);
  const [getdocumentType, setdocumentType] = useState([]);

  const [getState, setState] = useState([]);
  const [getCountry, setCountry] = useState([]);
  console.log("getTitle>>", getTitle);
  console.log("getcontactPosition>>", getcontactPosition);
  const contactTitleData = [
    {
      codeType: "title",
      code: "Company",
      description: "Company",
      name: "Company",
      id: "Company",
    },
    {
      codeType: "title",
      code: "Mr.",
      description: "Mr.",
      name: "Mr.",
      id: "Mr.",
    },
    {
      codeType: "title",
      code: "Mr. and Mrs.",
      description: "Mr. and Mrs.",
      name: "Mr. and Mrs.",
      id: "Mr. and Mrs.",
    },
    {
      codeType: "title",
      code: "Ms.",
      description: "Ms.",
      name: "Ms.",
      id: "Ms.",
    },
  ];
  const jobTitledata = [
    {
      codeType: "jobtitle",
      code: "101",
      description: "Manager",
      name: "101 - Manager",
      id: "101",
    },
  ];

  const [validation, setValidation] = useState({
    customerName: "",
    customerAddress: "",
    customerAddress2: "",
    customerCity: "",
    customerCityPostalCode: "",

    projectName: "",
    projectAddress: "",
    pojectAddress2: "",
    projectCity: "",
    projecityPostalCode: "",

    routerNumber: "",
    commission: "Yes",
    commissionAmount: "",
  });

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility7 = () => {
    setCardVisible7(!isCardVisible7);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };

  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
    validateName(name === "customerName" ? value : "")
      ? (errors.customerName = "")
      : (errors.customerName = message.VALID_CUSTOMER_NAME);
    validPostalCode(name === "customerCityPostalCode" ? value : "")
      ? (errors.customerCityPostalCode = "")
      : (errors.customerCityPostalCode = message.VALID_POSTAL_CODE);
    validateName(name === "projectName" ? value : "")
      ? (errors.projectName = "")
      : (errors.projectName = message.VALID_CUSTOMER_NAME);
    validPostalCode(name === "cityPostalCode" ? value : "")
      ? (errors.cityPostalCode = "")
      : (errors.cityPostalCode = message.VALID_POSTAL_CODE);
    validPostalCode(name === "projecityPostalCode" ? value : "")
      ? (errors.projecityPostalCode = "")
      : (errors.projecityPostalCode = message.VALID_POSTAL_CODE);
    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  const [formInputs, setFormInputs] = useState({
    version: "v0",
    status: "Non Invited",
    category: "VENDOR",

    customerName: "",
    customerAddress: "",
    customerAddress2: "",
    customerCity: "",
    customerCountry: "IN - India",
    customerState: "IN - Karanataka",
    customerCityPostalCode: "",

    projectName: "",
    projectAddress: "",
    pojectAddress2: "",
    projectCity: "",
    projectCountry: "IN - India",
    projectState: "IN - Karanataka",
    projecityPostalCode: "",

    routerNumber: "",
    commission: "Yes",
    commissionAmount: "",

    fromAddress:
      "Bharathi Rock Products India PVT Ltd Sy No.9, Kanivenarayanapura(V), Muddenahalli Post,Chikkabalapura-562101",
    distance: "45",
  });
  const [disabled] = useState(false);
  console.log("formInputsRouteNumber>>", formInputs.routerNumber);
  useEffect(() => {
    dispatch(getSupplierCategorySelection()); // getSupplierCategorySelection store
    getMasterData();
  }, [dispatch]);

  useEffect(() => {
    // console.log(">>Check getDropdownData Data", getDropdownData);
    if (getDropdownData?.codeType === "country") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      getStateData(getDropdownData?.code);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  // console.log(">> formInputs", formInputs);

  const handleChange = ({ selectedRows }) => {
    let res = selectedCategoryData.filter(
      (item) => !selectedRows.some((obj) => obj._id === item._id)
    );
    setSelectedData(res);
    if (res.length === selectedRows.length || res.length === 0) {
      setDisabledRemove(false);
    } else {
      setDisabledRemove(true);
    }
  };

  // SAVE
  const handleSave = async () => {
    const requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== ""
    );
    if (anyFieldNotEmpty) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }
    if (!validateRequired(formInputs.customerName)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        customerName: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.customerAddress)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        customerAddress: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.customerAddress2)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        customerAddress2: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.customerCity)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        customerCity: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.customerCityPostalCode)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        customerCityPostalCode: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.projectName)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        projectName: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!validateRequired(formInputs.projectAddress)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        projectAddress: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.pojectAddress2)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        pojectAddress2: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.projectCity)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        projectCity: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.projecityPostalCode)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        projecityPostalCode: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.routerNumber)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        routerNumber: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    console.log(">> handleSave", formInputs);

    formInputs.initiatorName = "Self";
    formInputs.initiator = "Self";

    alert("form submitted");
    navigate(CustomerConstants.CUSTOMER_V1_COSTING_SHEET);
  };

  //Load Master Data
  const getMasterData = async () => {
    let obj = {
      codeType: "title",
    };
    await ItemService.getMasterDataSelf(obj).then((item) => {
      console.log(">> item! title", item);
      if (item?.status === 200) {
        setTitle(item?.data);
      } else {
        setTitle([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj1 = {
      codeType: "documentType",
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setdocumentType(item?.data);
      } else {
        setdocumentType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj2 = {
      codeType: "jobtitle",
    };
    await ItemService.getMasterDataSelf(obj2).then((item) => {
      console.log(">> item!", item);
      if (item?.status === 200) {
        setcontactPosition(item?.data);
      } else {
        setcontactPosition([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj3 = {
      codeType: "country",
    };
    await ItemService.getMasterDataSelf(obj3).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCountry(item?.data);
      } else {
        setCountry([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };
  // Onselect of Country state will load
  const getStateData = async (code) => {
    let obj1 = {
      codeType: "region",
      code: code,
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setState(item?.data);
      } else {
        setState([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  const navigateToLogin = () => {
    navigate(Constants.LOGIN);
  };

  // Inital Create
  let customerContactPersonLineItemInitialCol = [
    {
      name: "Job Title",
      selector: (row) => row.contactPosition || "--",
      cell: (row) => (
        <ComboboxField
          placeholder=""
          // data={getcontactPosition}
          data={jobTitledata}
          id="contactPosition"
          iconClassName="dropdownIcon"
          name="contactPosition"
          code="contactPositionCode"
          description="contactPositionDesc"
          setValue={formInputs.contactPosition}
          getvalue={setDropdownData}
          // required={true}
          error={validation.contactPosition}
        />
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Contact Title",
      selector: (row) => row.customerContactPerson || "--",
      cell: () => (
        <ComboboxField
          placeholder=""
          // data={getTitle}
          data={contactTitleData}
          id="contactTitle"
          iconClassName="dropdownIcon"
          name="contactTitle"
          code="contactTitleCode"
          description="contactTitleDesc"
          setValue={formInputs.contactTitle}
          getvalue={setDropdownData}
          // required={true}
          error={validation.contactTitle}
        />
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Contact Person",
      selector: (row) => row.customerContactPerson || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="customerContactPerson"
          placeholder=""
          value={row.customerContactPerson || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },

    {
      name: "Contact Number",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="customerNumber"
          placeholder=""
          value={row.customerNumber || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Email-ID",
      selector: (row) => row.customerEmail || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="customerEmail"
          placeholder=""
          value={row.customerEmail || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className=""
          onClick={() => removecustomerContactPersonItemRow(row.local_id)}
        >
          <i className="bi bi-trash text-danger fs-4" />
        </button>
      ),
      width: "120px",
    },
  ];
  let projectDetailContactPersonLineItemInitialCol = [
    {
      name: "Job Title",
      selector: (row) => row.contactPosition || "--",
      cell: (row) => (
        <ComboboxField
          placeholder=""
          data={jobTitledata}
          id="contactPosition"
          iconClassName="dropdownIcon"
          name="contactPosition"
          code="contactPositionCode"
          description="contactPositionDesc"
          setValue={formInputs.contactPosition}
          getvalue={setDropdownData}
          // required={true}
          error={validation.contactPosition}
        />
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Contact Title",
      selector: (row) => row.customerContactPerson || "--",
      cell: () => (
        <ComboboxField
          placeholder=""
          // data={getTitle}
          data={contactTitleData}
          id="contactTitle"
          iconClassName="dropdownIcon"
          name="contactTitle"
          code="contactTitleCode"
          description="contactTitleDesc"
          setValue={formInputs.contactTitle}
          getvalue={setDropdownData}
          // required={true}
          error={validation.contactTitle}
        />
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Contact Person",
      selector: (row) => row.projectContactPerson || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="projectContactPerson"
          placeholder=""
          value={row.projectContactPerson || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Contact Number",
      selector: (row) => row.projectNumber || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="projectNumber"
          placeholder=""
          value={row.projectNumber || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Email-ID",
      selector: (row) => row.projectEmail || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="projectEmail"
          placeholder=""
          value={row.projectEmail || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "220px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          onClick={() => removeprojectDetailContactPersonItemRow(row.local_id)}
        >
          <i className="bi bi-trash text-danger fs-4" />
        </button>
      ),
      width: "120px",
    },
  ];
  let ProjecetDocumentLineItemInitialCol = [
    {
      name: "Specificaton",
      selector: (row) => row.customerContactPerson || "--",
      cell: (row) => (
        <>
          <ComboboxField
            label=""
            placeholder=""
            data={productDocumentAttachment}
            id=""
            iconClassName="dropdownIcon"
            name="Specificaton"
            code="SpecificatonCode"
            description="SpecificatonDesc"
            // setValue={formInputs.country}
            // getvalue={setDropdownData}
            // required={true}
            error={validation.country}
          />
        </>
      ),
      sortable: true,
      width: "280px",
    },
    {
      name: "Upload",
      selector: (row) => row.specificationAttachements || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="specificationAttachements"
          placeholder=""
          type="file"
          value={row.specificationAttachements || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button onClick={() => removeProjecetDocumentItemRow(row.local_id)}>
          <i className="bi bi-trash text-danger fs-4" />
        </button>
      ),
      width: "120px",
    },
  ];

  let customerContactPersonLineItemInitialData = [
    {
      local_id: 1,
      customerContactPerson: "",
      customerDesignation: "",
      customerNumber: "",
      customerMaterialCode: "",
    },
  ];
  let projectDetailContactPersonLineItemInitialData = [
    {
      local_id: 1,
      projectContactPerson: "",
      projectNumber: "",
      projectEmail: "",
    },
  ];
  let ProjecetDocumentLineItemInitialData = [
    {
      local_id: 1,
      Specificaton: "",
      specificationAttachements: "",
    },
  ];
  const handleInputChange = (local_id, event) => {
    const { name, value } = event.target;
    setcustomerContactPersonLineItemsData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row
      )
    );
    setprojectDetailContactPersonLineItemsData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row
      )
    );
    setProjecetDocumentLineItemsData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row
      )
    );
  };
  /* customer Contact Person  */
  const [getcustomerContactPersonLineItemsCol] = useState(
    customerContactPersonLineItemInitialCol
  );
  const [
    getcustomerContactPersonLineItemsData,
    setcustomerContactPersonLineItemsData,
  ] = useState(customerContactPersonLineItemInitialData);
  const removecustomerContactPersonItemRow = (local_id) => {
    setcustomerContactPersonLineItemsData((prevPrograms) =>
      prevPrograms.filter((program) => program.local_id !== local_id)
    );
  };
  const addcustomerContactPersonItemRow = () => {
    setcustomerContactPersonLineItemsData((prevRows) => {
      customerContactPersonLineItemInitialData[0].local_id =
        prevRows.length + 1;
      customerContactPersonLineItemInitialData[0].purchasingReqDocumentItemNr =
        prevRows.length + 1; // make it to 3 digit 001, 002
      return [...prevRows, ...customerContactPersonLineItemInitialData];
    });
  };
  /* project Detail Contact Person  */
  const [getprojectDetailContactPersonLineItemsCol] = useState(
    projectDetailContactPersonLineItemInitialCol
  );
  const [
    getprojectDetailContactPersonLineItemsData,
    setprojectDetailContactPersonLineItemsData,
  ] = useState(projectDetailContactPersonLineItemInitialData);
  const removeprojectDetailContactPersonItemRow = (local_id) => {
    setprojectDetailContactPersonLineItemsData((prevPrograms) =>
      prevPrograms.filter((program) => program.local_id !== local_id)
    );
  };
  const addprojectDetailContactPersonItemRow = () => {
    setprojectDetailContactPersonLineItemsData((prevRows) => {
      projectDetailContactPersonLineItemInitialData[0].local_id =
        prevRows.length + 1;
      projectDetailContactPersonLineItemInitialData[0].purchasingReqDocumentItemNr =
        prevRows.length + 1; // make it to 3 digit 001, 002
      return [...prevRows, ...projectDetailContactPersonLineItemInitialData];
    });
  };

  /* project Document */
  const [getProjecetDocumentLineItemsCol] = useState(
    ProjecetDocumentLineItemInitialCol
  );
  const [getProjecetDocumentLineItemsData, setProjecetDocumentLineItemsData] =
    useState(ProjecetDocumentLineItemInitialData);
  const removeProjecetDocumentItemRow = (local_id) => {
    setProjecetDocumentLineItemsData((prevPrograms) =>
      prevPrograms.filter((program) => program.local_id !== local_id)
    );
  };
  const addProjecetDocumentItemRow = () => {
    setProjecetDocumentLineItemsData((prevRows) => {
      ProjecetDocumentLineItemInitialData[0].local_id = prevRows.length + 1;
      ProjecetDocumentLineItemInitialData[0].purchasingReqDocumentItemNr =
        prevRows.length + 1; // make it to 3 digit 001, 002
      return [...prevRows, ...ProjecetDocumentLineItemInitialData];
    });
  };

  /* ---------------------Document Type  03rd block-------- */

  const deleteDocumentType = (id) => {
    const updatedData1 = getDocumentTypeData.filter((doc) => doc.id !== id);
    setDocumentTypeData(updatedData1);
  };
  const addDocumentType = () => {
    const newDocument = {
      id: Date.now(),
      name: `Document ${getDocumentTypeData.length + 1}`,
      documentType: "",
      documentNumber: "",
      expirationDate: "",
      issuingAuthority: "",
      certificateCode: "",
    };
    setDocumentTypeData((prevData) => [...prevData, newDocument]);
  };
  const handleInputChangeDocumentType = (
    id,
    fieldName,
    value,
    description,
    descriptionVal
  ) => {
    // console.log(">> id", id);
    // console.log(">> fieldName", fieldName);
    console.log(">> description", description);
    console.log(">> descriptionVal", descriptionVal);

    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc
      )
    );
  };
  /* route tables */
  const routeTableCol = [
    {
      name: "Sl.No",
      selector: (row) => row.slNo || "--",
      cell: (row) => <>{row.slNo} </>,
      width: "150px",
    },
    {
      name: "RouteNr",
      selector: (row) => row.routeNo || "--",
      cell: (row) => <>{row.routeNo} </>,
      width: "220px",
    },
    {
      name: "Route",
      selector: (row) => row.route || "--",
      cell: (row) => <>{row.route} </>,
      width: "220px",
    },
    {
      name: "Toll",
      selector: (row) => row.toll || "--",
      cell: (row) => <>{row.toll} </>,
      width: "150px",
    },
    {
      name: "Rate",
      selector: (row) => row.rate || "--",
      cell: (row) => <>{row.rate} </>,
      width: "220px",
    },
    {
      name: "From",
      selector: (row) => row.fromAM || "--",
      cell: (row) => <>{row.fromAM} </>,
      width: "220px",
    },
    {
      name: "To",
      selector: (row) => row.toAM || "--",
      cell: (row) => <>{row.toAM} </>,
      width: "220px",
    },
    {
      name: "From",
      selector: (row) => row.fromPM || "--",
      cell: (row) => <>{row.fromPM} </>,
      width: "220px",
    },
    {
      name: "To",
      selector: (row) => row.toPM || "--",
      cell: (row) => <>{row.toPM} </>,
      width: "220px",
    },
  ];
  const route1TableData = [
    {
      slNo: 1,
      routeNo: 1,
      route: "Yalahanka",
      toll: 750,
      rate: 25,
      fromAM: "8:00 AM",
      toAM: "11:00 AM",
      fromPM: "3:30 PM",
      toPM: "8:00 PM",
    },
  ];

  const route2TableData = [
    {
      slNo: 1,
      routeNo: 2,
      route: "Melkote	",
      toll: 180,
      rate: 6,
      fromAM: "8:00 AM",
      toAM: "11:00 AM",
      fromPM: "3:30 PM",
      toPM: "8:00 PM",
    },
    {
      slNo: 2,
      routeNo: 2,
      route: "Doddabalapura",
      toll: 180,
      rate: 6,
      fromAM: "8:00 AM",
      toAM: "11:00 AM",
      fromPM: "3:30 PM",
      toPM: "8:00 PM",
    },
    {
      slNo: 3,
      routeNo: 2,
      route: "Doddabalapura	",
      toll: 360,
      rate: 12,
      fromAM: "8:00 AM",
      toAM: "11:00 AM",
      fromPM: "3:30 PM",
      toPM: "8:00 PM",
    },
    {
      slNo: 4,
      routeNo: 2,
      route: "Budigere",
      toll: 395,
      rate: 13,
      fromAM: "8:00 AM",
      toAM: "11:00 AM",
      fromPM: "3:30 PM",
      toPM: "8:00 PM",
    },
  ];
  const route3TableData = [
    {
      slNo: 1,
      routeNo: 3,
      route: "Free zone",
      toll: 0,
      rate: 0,
      fromAM: "00:00AM",
      toAM: "00:00AM",
      fromPM: "00:00PM",
      toPM: "00:00PM",
    },
  ];
  return (
    <main>
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Customer Registration</h2>
            <p className="subText">
              Register as a new Customer or Sub-Contractor with our Company
            </p>
            <hr />
            <Row className="mb-4">
              <Col xs={12} md={2} lg={2} className="text-left">
                <button className="btnBack" onClick={() => navigateToLogin()}>
                  <i className="bi bi-arrow-return-left"></i> Go Back Login
                </button>
              </Col>
              {/* Next Button*/}
              <Col
                xs={12}
                md={{ span: 2, offset: 8 }}
                lg={{ span: 2, offset: 8 }}
                className="text-left"
              >
                <button
                  className="btnTable"
                  onClick={handleSave}
                  disabled={disabled}
                >
                  <i className="bi bi-save"></i> Generate Costing Sheet
                </button>
              </Col>
            </Row>
            {/* customer details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CD</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Customer </span>
                      <span className="subHeaderTitle">Customer Details</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Customer Name"
                          extraLabel="As per the trade license"
                          name="customerName"
                          placeholder=""
                          value={formInputs.customerName || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation.customerName}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label=" Address Lines 1 / Street"
                          name="customerAddress"
                          placeholder=""
                          value={formInputs.customerAddress || ""}
                          onChange={onInputChange}
                          error={validation.customerAddress}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Address Line 2"
                          name="customerAddress2"
                          placeholder=""
                          value={formInputs.customerAddress2 || ""}
                          onChange={onInputChange}
                          error={validation.customerAddress2}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="City"
                          name="customerCity"
                          placeholder=""
                          value={formInputs.customerCity || ""}
                          onChange={onInputChange}
                          error={validation.customerCity}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Country"
                          placeholder=""
                          data={getCountry}
                          id="customerCountry"
                          iconClassName="dropdownIcon"
                          name="customerCountry"
                          code="customerCountryCode"
                          description="customerCountryDesc"
                          setValue={formInputs.customerCountry}
                          getvalue={setDropdownData}
                          required={true}
                          error={validation.customerCountry}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="State"
                          placeholder=""
                          data={getState}
                          id="customerState"
                          iconClassName="dropdownIcon"
                          name="customerState"
                          code="customerStateCode"
                          description="customerStateDesc"
                          setValue={formInputs.customerState}
                          getvalue={setDropdownData}
                          required={true}
                          error={validation.customerState}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Postal Code/PO Box"
                          name="customerCityPostalCode"
                          placeholder=""
                          value={formInputs.customerCityPostalCode}
                          onChange={onInputChange}
                          error={validation.customerCityPostalCode}
                          required={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*Customer Contact Person / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Contact Person</span>
                      <span className="subHeaderTitle">
                        Customer Contact Person
                      </span>
                    </Col>
                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      <button
                        className="btnTable"
                        onClick={addcustomerContactPersonItemRow}
                      >
                        <i className="bi bi-plus-lg"></i> Add
                      </button>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={getcustomerContactPersonLineItemsCol}
                          data={getcustomerContactPersonLineItemsData}
                          // progressPending={loading}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // selectableRows
                          onSelectedRowsChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* customer Doucment Type */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DT</span>
                    </Col>

                    <Col xs={4} md={9} lg={9}>
                      <span className="headerTitle"> Doucment Type</span>
                      <span className="subHeaderTitle">Doucment Type</span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button className="btnTable" onClick={addDocumentType}>
                          Add Document
                        </button>
                      </div>
                    </Col>
                    {/*  <Col xs={1} md={1} lg={1}>
                      <POCollabrationCommonFillter />
                    </Col> */}
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-sm-none d-md-flex d-lg-flex ">
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex justify-content-center">
                                          Document Type
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Expiration Date
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-3">
                                          Issuing Authority
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex justify-content-center">
                                          Attachments
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex justify-content-center">
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {getDocumentTypeData.map((doc, index) => (
                                      <Row key={doc.id}>
                                        <Col xs={12}>
                                          <hr className="mx-4 my-0 text-color-black" />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <ComboboxField
                                            label=""
                                            placeholder="Document type"
                                            data={getdocumentType}
                                            id="documentType"
                                            iconClassName="dropdownIcon"
                                            name="documentType"
                                            code="documentTypeCode"
                                            description="documentTypeDesc"
                                            setValue={doc?.documentType}
                                            getvalue={setDropdownData}
                                            index={doc.id}
                                            onChangeValue={
                                              handleInputChangeDocumentType
                                            }
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Document Number"
                                            value={doc.documentNumber}
                                            onChange={(e) =>
                                              handleInputChangeDocumentType(
                                                doc.id,
                                                "documentNumber",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            type="date"
                                            value={doc.expirationDate}
                                            onChange={(e) =>
                                              handleInputChangeDocumentType(
                                                doc.id,
                                                "expirationDate",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Issuing Authority"
                                            value={doc.issuingAuthority}
                                            onChange={(e) =>
                                              handleInputChangeDocumentType(
                                                doc.id,
                                                "issuingAuthority",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Certificate Code"
                                            type="file"
                                            onChange={(e) =>
                                              handleInputChangeDocumentType(
                                                doc.id,
                                                "certificateCode",
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <i
                                            onClick={() =>
                                              deleteDocumentType(doc.id)
                                            }
                                            className="bi bi-trash text-danger fs-4"
                                          />
                                        </Col>
                                      </Row>
                                    ))}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Project Details*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible4
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility4}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PD</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Project Details </span>
                      <span className="subHeaderTitle">Project Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible4 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Project Name"
                          extraLabel="As per the trade license"
                          name="projectName"
                          placeholder=""
                          value={formInputs.projectName || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation.projectName}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label=" Address Lines 1 / Street"
                          name="projectAddress"
                          placeholder=""
                          value={formInputs.projectAddress || ""}
                          onChange={onInputChange}
                          error={validation.projectAddress}
                          required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Address Line 2"
                          name="pojectAddress2"
                          placeholder=""
                          value={formInputs.pojectAddress2 || ""}
                          onChange={onInputChange}
                          error={validation.pojectAddress2}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="City"
                          name="projectCity"
                          placeholder=""
                          value={formInputs.projectCity || ""}
                          onChange={onInputChange}
                          error={validation.projectCity}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {/* <InputField
                          className="inputBox"
                          label="Country"
                          name="projectCountry"
                          placeholder=""
                          value={formInputs.projectCountry}
                          // onChange={onInputChange}
                          // error={validation.city}
                          required={true}
                          disabled={true}
                        /> */}
                        <ComboboxField
                          label="Country"
                          placeholder=""
                          data={getCountry}
                          id="projectCountry"
                          iconClassName="dropdownIcon"
                          name="projectCountry"
                          code="projectCountryCode"
                          description="projectCountryDesc"
                          setValue={formInputs.projectCountry}
                          getvalue={setDropdownData}
                          required={true}
                          error={validation.projectCountry}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {/* <InputField
                          className="inputBox"
                          label="State"
                          name="projectState"
                          placeholder=""
                          value={formInputs.projectState}
                          // onChange={onInputChange}
                          // error={validation.city}
                          required={true}
                          disabled={true}
                        /> */}
                        <ComboboxField
                          label="State"
                          placeholder=""
                          data={getState}
                          id="projectState"
                          iconClassName="dropdownIcon"
                          name="projectState"
                          code="projectStateCode"
                          description="projectStateDesc"
                          setValue={formInputs.projectState}
                          getvalue={setDropdownData}
                          required={true}
                          error={validation.projectState}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Postal Code/PO Box"
                          name="projecityPostalCode"
                          placeholder=""
                          value={formInputs.projecityPostalCode || ""}
                          onChange={onInputChange}
                          error={validation.projecityPostalCode}
                          required={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*project detail Contact Person / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PC</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Project Contacts</span>
                      <span className="subHeaderTitle">
                        Project Details Contact Person
                      </span>
                    </Col>
                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      <button
                        className="btnTable"
                        onClick={addprojectDetailContactPersonItemRow}
                      >
                        <i className="bi bi-plus-lg"></i> Add
                      </button>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible5 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    {" "}
                    {/* dynamicDropdown */}
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={getprojectDetailContactPersonLineItemsCol}
                          data={getprojectDetailContactPersonLineItemsData}
                          // progressPending={loading}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // selectableRows
                          onSelectedRowsChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* project aditional details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible6
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility6}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PD</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Project Document</span>
                      <span className="subHeaderTitle">Project Document</span>
                    </Col>
                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      <button
                        className="btnTable"
                        onClick={addProjecetDocumentItemRow}
                      >
                        <i className="bi bi-plus-lg"></i> Add
                      </button>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible6 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    {" "}
                    {/* dynamicDropdown */}
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={getProjecetDocumentLineItemsCol}
                          data={getProjecetDocumentLineItemsData}
                          // progressPending={loading}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // selectableRows
                          onSelectedRowsChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Locations and distance */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible9
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility9}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LD</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">
                        {" "}
                        Locations and distance{" "}
                      </span>
                      <span className="subHeaderTitle">
                        {" "}
                        Locations and distance{" "}
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible9 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        lg={6}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          label="From Address"
                          id="fromAddress"
                          name="fromAddress"
                          className="inputBox"
                          placeholder=""
                          value={formInputs.fromAddress}
                          // onChange={handleInputChange}
                          // required={mandatory}\
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        lg={6}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          label="To Address"
                          id="toAddress"
                          name="toAddress"
                          className="inputBox"
                          placeholder=""
                          value={
                            formInputs.projectName +
                            "," +
                            formInputs.projectAddress +
                            "," +
                            formInputs.pojectAddress2 +
                            "," +
                            formInputs.projectCountry +
                            "," +
                            formInputs.projectState +
                            "," +
                            formInputs.projecityPostalCode
                          }
                          // onChange={handleInputChange}
                          // required={mandatory}\
                          disabled={true}
                        />
                      </Col>
                      <Col
                        lg={3}
                        className="d-flex align-items-end commTopButtonRightLeftPadding"
                      >
                        <button className="btnTable">
                          Get Distance & Direction{" "}
                        </button>
                      </Col>
                      <Col lg={3} className="commTopButtonRightLeftPadding">
                        <InputField
                          className="inputBox"
                          label="Distance (KM)"
                          name="distance"
                          placeholder=""
                          value={formInputs.distance || ""}
                          onChange={onInputChange}
                          error={validation.distance}
                          // required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        lg={12}
                        className="d-flex justify-content-start commTopButtonRightLeftPadding"
                      >
                        <p className="p-0 m-0">
                          <sapn className="fw-bold">Note :</sapn>Distance Shown
                          is near to exact.Actual distance may slightly vary
                        </p>
                      </Col>
                      <Col lg={12} className="commTopButtonRightLeftPadding">
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3881.2252235877504!2d77.6717547!3d13.3983762!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb1e5c17621356d%3A0x96df4953ce95467f!2sBharathi%20Rock%20Products%20India%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1737531786537!5m2!1sen!2sin"
                          title="Google Map showing Bharathi Rock Products India Pvt Ltd location"
                          width="600"
                          height="450"
                          style={{ border: "0" }}
                          allowfullscreen
                          loading="lazy"
                          referrerpolicy="no-referrer-when-downgrade"
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Aditional details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible7
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility7}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AD</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Additional Details</span>
                      <span className="subHeaderTitle">Additional Details</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible7 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Route Number"
                          extraLabel="Certification?"
                          name="routerNumber"
                          code="routerNumberCode"
                          description="routerNumberDesc"
                          data={routNumberDropdownOption}
                          id="ISOCertification"
                          iconClassName="dropdownIcon"
                          onChange={setDropdownData}
                          setValue={formInputs.routerNumber}
                          error={validation.routerNumber}
                          getvalue={setDropdownData}
                          required={true}
                          // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Commission"
                          placeholder=""
                          data={dropdownOption}
                          id="commission"
                          iconClassName="dropdownIcon"
                          name="commission"
                          code="commissionCode"
                          description="commissionDesc"
                          setValue={formInputs.commission || "Yes"}
                          getvalue={setDropdownData}
                          required={true}
                          error={validation.commission}
                        />
                      </Col>
                      {formInputs.commission !== ("No" || "") && (
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Commission Amount"
                            name="commissionAmount"
                            placeholder=""
                            value={formInputs.commissionAmount || ""}
                            onChange={onInputChange}
                            error={validation.commissionAmount}
                            required={true}
                          />
                        </Col>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Route details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RD</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Route Detail</span>
                      <span className="subHeaderTitle">Route Details</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible8 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <DataTable
                        title=""
                        columns={routeTableCol}
                        data={
                          formInputs.routerNumber === "1"
                            ? route1TableData
                            : formInputs.routerNumber === "2"
                            ? route2TableData
                            : formInputs.routerNumber === "3"
                            ? route3TableData
                            : ""
                        }
                        // progressPending={loading}
                        paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                        pagination
                        // paginationServer
                        // paginationTotalRows={totalRows}
                        // onChangeRowsPerPage={handlePerRowsChange}
                        // onChangePage={handlePageChange}
                        // selectableRows
                        onSelectedRowsChange={handleChange}
                      />
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
    </main>
  );
};

export default GodownRegistration;
